// extracted by mini-css-extract-plugin
export default {"noAccess":"no-access_noAccess__-lMk6"};